import { render, staticRenderFns } from "./ClassifierDetail.vue?vue&type=template&id=3d46fa0c&scoped=true"
import script from "./ClassifierDetail.vue?vue&type=script&lang=js"
export * from "./ClassifierDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassifierDetail.vue?vue&type=style&index=0&id=3d46fa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46fa0c",
  null
  
)

export default component.exports